import { z } from 'zod';
export const scopeTypeSchema = z.enum(['GLOBAL', 'MTU', 'ORG_UNIT', 'WAREHOUSE']);
export const scopeSchema = z
    .object({ type: scopeTypeSchema, id: z.string().regex(/^\d+$/).nullable() })
    .refine((s) => (s.type === 'GLOBAL' ? s.id === null : s.id !== null), {
    message: 'GLOBAL doirada id bo\'lmaydi, boshqa doiralarda id majburiy',
});
//# sourceMappingURL=scope.js.map